export default function Crown({ style }) {
  return (
    <svg
      className={style}
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3074_29113)'>
        <path
          d='M30.3547 6.08751C29.8675 5.88456 29.3309 5.83121 28.8132 5.93427C28.2956 6.03732 27.8203 6.29211 27.448 6.66618L24 10.1142L17.8853 3.99951C17.3853 3.49959 16.7071 3.21875 16 3.21875C15.2929 3.21875 14.6147 3.49959 14.1147 3.99951L8 10.1142L4.552 6.66618C4.17906 6.29336 3.70396 6.03947 3.18675 5.93663C2.66954 5.83378 2.13345 5.88659 1.64625 6.08837C1.15906 6.29016 0.74262 6.63187 0.449596 7.07029C0.156571 7.50872 0.000112598 8.02418 0 8.55151L0 22.6662C0.00211714 24.4336 0.705176 26.1281 1.95496 27.3779C3.20474 28.6277 4.89921 29.3307 6.66667 29.3328H25.3333C27.1008 29.3307 28.7953 28.6277 30.045 27.3779C31.2948 26.1281 31.9979 24.4336 32 22.6662V8.55151C32.0001 8.02414 31.8439 7.50856 31.551 7.06998C31.2582 6.6314 30.8418 6.2895 30.3547 6.08751ZM29.3333 22.6662C29.3333 23.727 28.9119 24.7445 28.1618 25.4946C27.4116 26.2448 26.3942 26.6662 25.3333 26.6662H6.66667C5.6058 26.6662 4.58839 26.2448 3.83824 25.4946C3.08809 24.7445 2.66667 23.727 2.66667 22.6662V8.55151L7.05733 12.9422C7.30737 13.1921 7.64645 13.3326 8 13.3326C8.35355 13.3326 8.69263 13.1921 8.94267 12.9422L16 5.88485L23.0573 12.9422C23.3074 13.1921 23.6464 13.3326 24 13.3326C24.3536 13.3326 24.6926 13.1921 24.9427 12.9422L29.3333 8.55151V22.6662Z'
          fill='#8FC045'
        />
      </g>
      <defs>
        <clipPath id='clip0_3074_29113'>
          <rect width='32' height='32' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
